/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerListProjectSightContractsQueryResponse, TrimbleItemsControllerListProjectSightContractsQueryParams, TrimbleItemsControllerListProjectSightContracts401, TrimbleItemsControllerListProjectSightContracts403 } from "../../models/trimbleController/TrimbleItemsControllerListProjectSightContracts";

function getTrimbleItemsControllerListProjectSightContractsUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble/projectsight/contracts` as const }  
  return res
}

/**
 * @summary List the connected ProjectSight project's contracts and their attached files
 * {@link /api/v1/trimble/projectsight/contracts}
 */
export async function trimbleItemsControllerListProjectSightContracts(params: TrimbleItemsControllerListProjectSightContractsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerListProjectSightContractsQueryResponse, ResponseErrorConfig<TrimbleItemsControllerListProjectSightContracts401 | TrimbleItemsControllerListProjectSightContracts403>, unknown>({ method : "GET", url : getTrimbleItemsControllerListProjectSightContractsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}